/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SecurityRelationshipGrid extends SiteEntityGrid<SecurityRelationshipRow, any> {
        protected getColumnsKey() { return SecurityRelationshipColumns.columnsKey; }
        protected getDialogType() { return SecurityRelationshipDialog; }
        protected getIdProperty() { return SecurityRelationshipRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityRelationshipRow.localTextPrefix; }
        protected getService() { return SecurityRelationshipService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected getColumns() {
            return super.getColumns().filter(x => x.field != SecurityRelationshipRow.Fields.SecurityId);
        }

        protected getGridCanLoad() {
            return !!this._securityId;
        }

        protected addButtonClick() {
            if (!this._securityId)
                return;

            this.editItem({
                SecurityId: this.securityId
            });
        }

        private _securityId: number;

        public get securityId() {
            return this._securityId;
        }

        public set securityId(value: number) {
            if (this._securityId != value) {
                this._securityId = value;
                this.setEquality(SecurityRelationshipRow.Fields.SecurityId, value);
                this.refresh();
            }
        }
    }
}